import * as types from './types';
import Vue from 'vue';
import api from '@/api/auth';
import * as http from '@/http';
import store from '@/store';
import {getRuntimeConfig} from '../../../http';

export default {

  check({ commit, dispatch }, session) {
    if (session === undefined) {
      session = JSON.parse(localStorage.getItem('es-session'));
    }
    if (session === undefined || session === null) {
      commit(types.SET_SESSION, { auth: false, guest: false, token: undefined });
      commit(types.SET_PROFILE, {
        options: undefined,
        role: undefined,
        isFinalized: false,
      });
    } else {
      commit(types.SET_SESSION, session);
      http.setAuthorization(session.token);
      Vue.prototype.$stonly.setToken(session.token);
      dispatch('getProfile');
    }
  },
  getProfile({ commit }) {
    return api.getProfile().then((response) => {
      if (response.status === 'success' && response.data.profile) {
        commit(types.SET_PROFILE, response.data.profile);

        localStorage.removeItem('es-profile');
        localStorage.setItem('es-profile', JSON.stringify(response.data.profile));
        return Promise.resolve(response);
      }
      commit(types.SET_PROFILE, {
        options: undefined,
        role: undefined,
        isFinalized: false,
      });
      return Promise.reject(response);
    });
  },

  loginWithSession({ commit, dispatch }, session) {
    console.log(session);
    store.dispatch('application/startLoading');

    // save data into store
    http.setAuthorization(session.token);
    Vue.prototype.$stonly.setToken(session.token);
    commit(types.SET_SESSION, session);

    return dispatch('getProfile').then((response) => {
      localStorage.clear();
      localStorage.setItem('es-session', JSON.stringify(session));
      localStorage.setItem('es-profile', JSON.stringify(response.data.profile));
      return Promise.resolve(response);
    }).catch((err) => {
      commit(types.SET_SESSION, { auth: false, guest: false, token: undefined });
      commit(types.SET_PROFILE, { options: undefined, role: undefined, isFinalized: false });
      store.dispatch('application/displaySnackbar', {
        text: Vue.$i18n.t('store.login.error'),
        time: 5,
        type: 'error',
        centered: false,
      });
      return Promise.reject(err);
    }).finally(() => {
      store.dispatch('application/finishLoading');
    });
  },

  login({ commit }, params) {
    store.dispatch('application/startLoading');
    return api.login(params)
      .then((response) => {
        console.log(response);
        if (response.status === 'success') {
          console.log(response.data);
          if (response.data.edsv3AuthResponse !== undefined) {
            getRuntimeConfig().then((config) => {
              document.location.href = `${config.EDSV3_FRONT_URL}/autologin/${response.data.edsv3AuthResponse}`;
              return Promise.resolve(response);
            });
          }

          if (response.data.edsv3BadLogin === true) {
            getRuntimeConfig().then((config) => {
              document.location.href = `${config.EDSV3_FRONT_URL}/badLogin`;
              return Promise.resolve(response);
            });
          }

          const session = {
            auth: true,
            guest: response.data.profile.role === 'signer',
            token: response.data.sessionId,
          };
          // save data into store
          commit(types.SET_SESSION, session);
          commit(types.SET_PROFILE, response.data.profile);
          // set request token
          http.setAuthorization(response.data.sessionId);
          Vue.prototype.$stonly.setToken(response.data.sessionId);
          // store session data in localStorage
          localStorage.clear();
          localStorage.setItem('es-session', JSON.stringify(session));
          localStorage.setItem('es-profile', JSON.stringify(response.data.profile));
          return Promise.resolve(response);
        }
        return Promise.reject(response);
      })
      .catch((err) => {
        commit(types.SET_SESSION, { auth: false, guest: false, token: undefined });
        commit(types.SET_PROFILE, { options: undefined, role: undefined, isFinalized: false });
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.login.error'),
          time: 5,
          type: 'error',
          centered: false,
        });
        return Promise.reject(err);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },

  stepLogin({ commit }, params) {
    store.dispatch('application/startLoading');
    return api.loginWithStepUUID(params)
      .then((response) => {
        if (response.status === 'success') {
          if (response.data.edsv3AuthResponse !== undefined) {
            getRuntimeConfig().then((config) => {
              document.location.href = `${config.EDSV3_FRONT_URL}/autologin-stepuuid/${response.data.edsv3AuthResponse}`;
            });
          }

          const session = {
            auth: true,
            guest: response.data.profile.role === 'signer',
            token: response.data.sessionId,
          };
          // save data into store
          commit(types.SET_SESSION, session);
          commit(types.SET_PROFILE, response.data.profile);
          // set request token
          http.setAuthorization(response.data.sessionId);
          Vue.prototype.$stonly.setToken(response.data.sessionId);
          // store session data in localSorage
          localStorage.clear();
          localStorage.setItem('es-session', JSON.stringify(session));
          localStorage.setItem('es-profile', JSON.stringify(response.data.profile));
          return Promise.resolve(response);
        }
        return Promise.reject(response);
      })
      .catch((err) => {
        commit(types.SET_SESSION, { auth: false, guest: false, token: undefined });
        commit(types.SET_PROFILE, { options: undefined, role: undefined, isFinalized: false });
        if (err.data.message !== 'access token not valid anymore') {
          store.dispatch('application/displaySnackbar', {
            text: Vue.$i18n.t('store.stepLogin.error'),
            time: 5,
            type: 'error',
            centered: false,
          });
        }
        return Promise.reject(err);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },

  thirdPartyLogin({ commit }, params) {
    const session = {
      auth: true,
      guest: true,
      token: params.uuid,
    };
    // save data into store
    commit(types.SET_SESSION, session);
    commit(types.SET_PROFILE, {});
    // set request token
    http.setAuthorization(params.uuid);
    Vue.prototype.$stonly.setToken(params.uuid);

    localStorage.clear();
    localStorage.setItem('es-session', JSON.stringify(session));
    localStorage.setItem('es-profile', JSON.stringify({}));
    return Promise.resolve(session);
  },

  updateUserInfos({ commit }, user) {
    commit(types.SET_USER_INFOS, user);
  },

  getUserInfos({ commit }) {
    store.dispatch('application/startLoading');
    return api.getUserInfos()
      .then((response) => {
        if (response.status === 'success') {
          if (response.data.account !== undefined && response.data.account.email) {
            Vue.prototype.$stonly.setIdentify(response.data.account.userId);
            Vue.prototype.$stonly.setEmail(response.data.account.email);
            Vue.prototype.$stonly.setUserId(response.data.account.userId);
            Vue.prototype.$stonly.setIsMainUser(response.data.account.isMainUser === '1');
            Vue.prototype.$stonly.sendData();
          }
          commit(types.SET_USER_INFOS, response.data.account);
          return Promise.resolve(response);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.userInfos.error'),
          time: 5,
          type: 'error',
        });
        commit(types.SET_USER_INFOS, undefined);
        Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  getUsageDatas({ commit }) {
    if (localStorage.getItem(`usageDatas`) !== undefined) {
      commit(types.SET_USAGE_DATAS, JSON.parse(localStorage.getItem('usageDatas')));
    }

    return api.getUsageDatas()
      .then((response) => {
        if (response.status === 'success') {
          commit(types.SET_USAGE_DATAS, response.data);
          localStorage.setItem('usageDatas', JSON.stringify(response.data));
          return Promise.resolve(response.data);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.usageDatas.error'),
          time: 5,
          type: 'error',
        });
        commit(types.SET_USAGE_DATAS, undefined);
        Promise.reject(error);
      });
  },

  clear({ commit }) {
    commit(types.SET_SESSION, { auth: false, guest: false, token: undefined });
    commit(types.SET_PROFILE, { options: undefined, role: undefined, isFinalized: false });
    commit(types.SET_USAGE_DATAS, undefined);
    commit(types.SET_USER_INFOS, undefined);
  },
  clearAll() {
    store.dispatch('auth/clear');
    store.dispatch('signworkflows/clear');
    store.dispatch('signatory/clear');
  },
  callApiLogout() {
    return api.logout();
  },
  renewToken({commit}, params) {
    store.dispatch('application/startLoading');
    return api.renewToken(params)
      .then((response) => {
        if (response.status === 'success') {
          return Promise.resolve(response.data);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.renewToken.error'),
          time: 5,
          type: 'error',
        });
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  logout() {
    localStorage.clear();
    api.logout().then(() => location.reload());
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js